import { AxiosError } from 'axios';
import adminApi from '../../api/adminApi';
import useStore from '../../store/store';

export interface AddKitTypeParams {
    kitTypeCategoryId: number;
    type: string;
    description?: string;
    turnaroundTime?: string;
    requiredSample?: string;
    transportTempo?: string;
    providedReports?: string;
    kitTypeCatalogueId: string;
    available?: boolean;
    trf?: File;
}

const AddKitType = async (params: AddKitTypeParams) => {
    const { setFormError, setIsLoading } = useStore.getState();
    setIsLoading(true);

    try {
        const formData = new FormData();

        formData.append(
            'kitTypeCategoryId',
            params.kitTypeCategoryId.toString()
        );
        formData.append('type', params.type);
        formData.append('kitTypeCatalogueId', params.kitTypeCatalogueId);

        const optionalFields: Partial<AddKitTypeParams> = {
            description: params.description,
            turnaroundTime: params.turnaroundTime,
            requiredSample: params.requiredSample,
            transportTempo: params.transportTempo,
            providedReports: params.providedReports,
        };

        for (const [key, value] of Object.entries(optionalFields)) {
            if (value !== undefined && value !== null) {
                if (value instanceof File) {
                    formData.append(key, value);
                } else if (value !== '') {
                    formData.append(key, value.toString());
                }
            }
        }

        if (params.available !== undefined && params.available !== null) {
            formData.append('available', params.available.toString());
        }

        if (params.trf) {
            formData.append('trf', params.trf);
        }

        const response = await adminApi.post('/kit-type/add', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        const { success, errCode } = response.data;
        if (success) {
            setFormError('');
        } else if (errCode) {
            setFormError(errCode);
        } else {
            setFormError('other');
        }
    } catch (e: unknown) {
        if (e instanceof AxiosError) {
            console.error(e.response?.data);
            setFormError('');
            setTimeout(() => setFormError(e.code ?? 'other'), 0);
        } else {
            setFormError('');
            setTimeout(() => setFormError('other'), 0);
        }
    } finally {
        setIsLoading(false);
    }
};

export default AddKitType;
